import { func, number, oneOfType, shape, string } from 'prop-types'
import MapPinIcon from '../../../../atoms/icons/map-pin-icon'

const MarkerIcon = ({ className, image, markerId, sx, ...props }) =>
	image ? (
		// eslint-disable-next-line @next/next/no-img-element
		<img className={className} src={image} alt={markerId} style={sx} {...props} />
	) : (
		<MapPinIcon className={className} sx={sx} {...props} />
	)

const Marker = ({ className, lat, lng, markerId, onClick, markerProps }) => {
	return (
		<MarkerIcon
			className={className}
			lat={lat}
			lng={lng}
			onClick={() => (onClick ? onClick(markerId) : null)}
			sx={{ cursor: 'pointer', fontSize: 40 }}
			{...markerProps}
		/>
	)
}

Marker.defaultProps = {}
Marker.propTypes = {
	className: string,
	/**
	 * The id of the marker.
	 */
	markerId: oneOfType([number, string]).isRequired,
	/**
	 * The latitude of the marker.
	 */
	lat: number.isRequired,
	/**
	 * The longitude of the marker.
	 */
	lng: number.isRequired,
	/**
	 * The function to call when the marker is clicked.
	 */
	onClick: func,
	markerProps: shape({ ...(MapPinIcon.propTypes || Image.propTypes) }),
}

export default Marker
